import React from "react";
import "./WhatWeDo.css";
import devIcon from "../../assets/Development.png";
import hrIcon from "../../assets/HRCon.png";
import internshipIcon from "../../assets/InternPro.png";
import marketingIcon from "../../assets/DigitalMarketing.png";
import { motion } from "framer-motion";

const services = [
  {
    icon: devIcon,
    title: "Web & Mobile App Development",
    description: "From idea to launch, we build what clicks.",
  },
  {
    icon: hrIcon,
    title: "HR Consulting",
    description: "Your HR partner for smarter people management",
  },
  {
    icon: internshipIcon,
    title: "Internship Programs",
    description: "Real skills, real projects, no boring textbooks.",
  },
  {
    icon: marketingIcon,
    title: "Digital Marketing",
    description: "Strategies that get you seen - and remembered.",
  },
];

const WhatWeDoSection = () => (
  <section className="wwd-section">
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h2 className="wwd-section-title">What We Do</h2>
    </motion.div>
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <p className="wwd-section-subtitle">
        At WebBunny Development, we empower brands through technology, people &
        digital growth.
      </p>
    </motion.div>
    <div className="wwd-services-grid">
      {services.map((service) => (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <article
            key={service.title}
            className="wwd-service-card"
            tabIndex="0"
          >
            <img
              src={service.icon}
              alt={`${service.title} icon`}
              className="wwd-service-icon"
            />
            <h3 className="wwd-service-title">{service.title}</h3>
            <p className="wwd-service-description">{service.description}</p>
          </article>
        </motion.div>
      ))}
    </div>
  </section>
);

export default React.memo(WhatWeDoSection);
